<template>
  <!--基本信息的准考证填涂区 -->
  <div
    class="basics_wrap"
    :class="{'trd-wrap': answerSheet.acCardPanes == 3}"
    style="height: 100%; box-sizing: border-box"
  >
    <div class="basics-num-code" v-if="answerSheet.acCardStudentCodeType == 2">
      <div class="num-name">考号</div>
      <div class="num-list">
        <div
          class="num"
          v-for="n in answerSheet.acCardExamNumber"
          :key="'stuNum' + n"
        ></div>
      </div>
    </div>
    <div
      class="basics-full-filling"
      :style="sty"
      v-if="answerSheet.acCardStudentCodeType == 0"
    >
      <div
        class="f-name"
        :style="
          (answerSheet.acCardExamNumber <= 10 &&
            answerSheet.acCardPanes !== 3) ||
          (answerSheet.acCardExamNumber < 9 && answerSheet.acCardPanes === 3)
            ? 'border-top: 1px solid #000000'
            : 'border-top: 1px solid #000000'
        "
      >
        准考证
      </div>
      <div class="f-empty" :class="{'fill-over': answerSheet.acCardExamNumber >=13 }">
        <div
          class="empty"
          v-for="em in answerSheet.acCardExamNumber"
          :key="'em' + em"
        ></div>
      </div>
      <div class="f-fill"  :class='{"fill-over": answerSheet.acCardExamNumber >= 13}'>
        <div
          class="fill"
          v-for="em in answerSheet.acCardExamNumber"
          :key="'em1' + em"
        >
          <div class="f-num" v-for="num in 10" :key="'num' + num">
            <span>[{{ num - 1 }}]</span>
          </div>
        </div>
      </div>
    </div>
    <template v-if="answerSheet.acCardPanes != 3">
      <div
        class="basics-bar-code"
        v-if="answerSheet.acCardStudentCodeType == 1"
      >
        <div class="bar">
          <p>粘条形码区</p>
          <p>（勿粘出方框）</p>
        </div>
      </div>
    </template>
    <template
      v-else
      style="
        height: 100%;
        border-bottom: 1px solid #000;
        box-sizing: border-box;
      "
    >
      <div
        class="basics-bar-code1"
        v-if="answerSheet.acCardStudentCodeType == 1"
      >
        <!-- <div class="bar-name">条形码</div> -->
        <div class="bar">
          <p>粘条形码区</p>
          <p>（勿粘出方框）</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//基础信息区
export default {
  name: "basicsFullFilling",
  props: {
    sty: Object,
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.basics-full-filling {
  border: 1px solid #000000;
  border-top: none;
  border-left: none;
  &.no-l-bor {
    border-left: 0;
  }

  &.no-t-bor {
    border-top: 0;
  }

  .f-name {
    height: 39px;
    line-height: 39px;
    background: #f2f2f2;
    text-align: center;
    border-bottom: 1px solid #000000;
    color: var(--card-color)
  }

  .f-empty {
    display: flex;
    border-bottom: 1px solid #000000;
  }

  .empty {
    width: 27px;
    height: 40px;
    border-right: 1px solid #000000;
  }

  // .fill-over {
  //       .empty,
  //       .fill {
  //         &:last-child {
  //           border-right: none;
  //         }
  //       }
  //   }
  .fill {
    border-right: 1px solid #000000;
    width: 27px;
    text-align: center;
  }

  .f-num {
    height: 20px;
    line-height: 20px;
    span{
      display: inline-block;
      width: 14px;
      height: 12px;
      line-height: 12px;
      text-emphasis: none;
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  .f-fill {
    display: flex;   
  }
}
.trd-wrap {
  .basics-full-filling {
    height: calc(100% - 1px);
  }
  .f-num {
    // height: 20px;
    // line-height: 20px;

    // height: 100%;
    // line-height: 100%;
    align-items: center;
    justify-content: center;
    border-right: none;
    // span{
    //   display: inline-block;
    //   width:19px;
    //   height:15px;
    //   overflow: hidden;
    // }
  }

  .f-fill {
    display: flex;
    justify-content: space-around;
    height: calc(100% - 82px);
   
  }
}

.basics-bar-code {
  width: 300px;
  border: 1px solid #000000;
  text-align: center;
  border-left: 0;
  border-top: 0;

  // border-top: 0;
  //border-radius: 10px;
  //margin-left:10px;
  padding: 59px 0;

  .bar {
    width: 200px;
    height: 60px;
    padding-top: 20px;
    border-radius: 10px;
    border: 1px dashed #000000;
    margin: 0 auto;
  }
}

.basics-bar-code1 {
  border: 1px solid #000000;
  // border-bottom: 0;
  text-align: center;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 30px;
  border-left: none;
  box-sizing: border-box;
  .bar-name {
    width: 40px;
    height: 52px;
    line-height: 52px;
    background: #f2f2f2;
    text-align: center;
    border-right: 1px solid #000;
    padding: 10px 0;
  }

  .bar {
    width: 200px;
    height: 50px;
    padding-top: 20px;
    border-radius: 10px;
    border: 1px dashed #000;
    margin: 100px auto;
  }
}

.basics-num-code {
  display: flex;
  line-height: 48px;
  border: 1px solid #000;
  border-top: 0;
  border-bottom: 0;
  height: 48px;

  .num-name {
    width: 40px;
    text-align: center;
    // background: #f2f2f2;
    // border-right: 1px solid #000;
  }

  .num {
    width: 18px;
    height: 28px;
    border: 1px solid #000;
    border-radius: 3px;
    margin-top: 10px;
    margin-left: 5px;
  }

  .num-list {
    display: flex;
  }
}
.basics_wrap {
  height: 100%;
}
.basics_wrap {
  .basics-full-filling {
    border-color: var(--card-color);
    .f-name {
      border-color: var(--card-color);
      border-top: 1px solid var(--card-color) !important;
    }
    .f-empty,
    .empty,
    .fill {
      border-color: var(--card-color);
    }
    .f-num {
      color: var(--card-color);
    }
  }
}
</style>
